module.exports = __webpack_public_path__ + "media/images/brand/photo01-4217c4ab5c156155a2c6bb662c4afb9c.png";